<template>
  <el-dialog
    :modal-append-to-body="false"
    :append-to-body="true"
    :title="title"
    :visible.sync="dialogVisible"
    width="900px"
    top="2%"
  >
    <el-button
      size="small"
      type="primary"
      style="margin: 10px 0"
      @click="add"
      v-if="obj.CanEdit || title === '開單'"
    >
      新增
    </el-button>
    <el-table scripe :data="tableData" style="width: 100%; color: black">
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.CanEdit"
            size="small"
            type="danger"
            @click="handleDel(scope.$index)"
          >
            刪除
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="Date" prop="Date">
        <template slot-scope="scope">
          {{ scope.row.Date }}
        </template>
      </el-table-column>
      <el-table-column label="Description" min-width="150">
        <template slot-scope="scope">
          <el-select
            :disabled="!scope.row.CanEdit"
            v-model="scope.row.Description"
            clearable
            filterable
            allow-create
            placeholder="請選擇"
            size="small"
          >
            <el-option
              v-for="item in descriptions"
              :key="item.CODE"
              :label="item.CODE"
              :value="item.CODE"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Amount" prop="Amount" min-width="130">
        <template slot-scope="scope">
          <el-input-number
            :disabled="!scope.row.CanEdit"
            v-model="scope.row.Amount"
            size="small"
          />
        </template>
      </el-table-column>
      <el-table-column label="Remark" prop="Remark" min-width="280">
        <template slot-scope="scope">
          <el-input
            type="textarea"
            :rows="1"
            v-model="scope.row.Remark"
            maxlength="500"
            placeholder="不超過500字"
            size="small"
            :disabled="!scope.row.CanEdit"
          >
          </el-input> </template
      ></el-table-column>
    </el-table>
    <strong>
      Balance:
      {{ moneyStr(balance) }}
    </strong>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        size="small"
        @click="submit"
        v-if="obj.CanEdit || title === '開單'"
        >提交</el-button
      >
      <el-button size="small" @click="dialogVisible = false" type="info"
        >關閉</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  financeDetail,
  updDebitNote,
  addDebitNote,
  getPaymentDescription,
} from "@/api/guest/list";
export default {
  data() {
    return {
      options: [],
      descriptions: [],
      obj: {},
      method: "",
      title: "",
      code: "",
      dialogVisible: false,
      tableData: [],
    };
  },
  created() {
    getPaymentDescription().then((res) => {
      this.descriptions = res.data;
    });
  },
  computed: {
    balance() {
      return this.tableData.reduce((total, item) => {
        return total + item.Amount;
      }, 0);
    },
  },
  watch: {},
  methods: {
    submit() {
      this.$confirm("確認提交?").then(() => {
        if (this.title === "變更") {
          updDebitNote({
            OperateCode: this.obj.OperateCode,
            DebitNoteDetailGroup: this.tableData.map((_) => {
              return {
                Amount: _.Amount,
                Description: _.Description,
                IsNew: _.IsNew || false,
                Remark: _.Remark,
                DetailCode: _.DetailCode,
              };
            }),
          }).then(() => {
            this.dialogVisible = false;
            this.$emit("handleSuccess");
            this.$message({
              message: this.$t("app.opeSuccess"),
              type: "success",
            });
          });
        } else {
          addDebitNote({
            BookingCode: this.code,
            DebitNoteDetailGroup: this.tableData.map((_) => {
              return {
                Amount: _.Amount,
                Description: _.Description,
                IsNew: _.IsNew || false,
                Remark: _.Remark,
                DetailCode: _.DetailCode,
              };
            }),
          }).then(() => {
            this.dialogVisible = false;
            this.$emit("handleSuccess");
            this.$message({
              message: this.$t("app.opeSuccess"),
              type: "success",
            });
          });
        }
      });
    },
    add() {
      this.tableData.push({
        IsNew: true,
        Amount: this.totalFee,
        Date: "",
        Description: "",
        Remark: "",
        CanEdit: true,
        DetailCode: "",
      });
    },
    handleDel(index) {
      this.tableData.splice(index, 1);
    },
    newModal(code, totalFee) {
      this.title = "開單";
      this.code = code;
      this.method = "";
      this.dialogVisible = true;
      this.tableData = [];
      this.totalFee = totalFee;
    },
    moneyStr(num) {
      const arr = num.toString().split(".");
      arr[0] = arr[0].toLocaleString().replace(/^0*/, "");
      if (arr[0] === "") {
        arr[0] = "0";
      }
      arr[1] = arr[1] || "00";
      return arr[0] + "." + (arr[1] + "00").slice(0, 2);
    },
    edit(row) {
      this.title = "變更";
      this.dialogVisible = true;
      this.obj = JSON.parse(JSON.stringify(row));
      this.getList();
    },
    getList() {
      financeDetail({
        OperateCode: this.obj.OperateCode,
      }).then((res) => {
        this.tableData = res.data.DebitNoteDetailGroup.map((i) => {
          i.IsNew = false;
          return i;
        });
      });
    },
  },
};
</script>
